import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NoAuthRouter from '../components/routers/NoAuthRouter';

const CV = React.lazy(() => import('features/cv'));
const Main = React.lazy(() => import('features/main'));
const Game = React.lazy(() => import('features/games'));
const Phrase = React.lazy(() => import('features/phrase'));
const Category = React.lazy(() => import('features/category'));
const SignIn = React.lazy(() => import('features/auth/sign-in'));
const NotFound = React.lazy(() => import('components/NotFound'));

const Routes = () => (
  <Switch>
    {/* <Redirect exact from="/" to="/phrases" /> */}
    <Route exact path="/" component={Main} />
    <Route path="/games" component={Game} />
    <NoAuthRouter path="/sign-in" component={SignIn} />
    <Route exact path="/cv" component={CV} />
    <Route path="/phrases" component={Phrase} />
    <Route path="/categories" component={Category} />
    <Route component={NotFound} />
  </Switch>
);

export default Routes;
